<template>
  <div class="app-container">
  </div>
</template>

<script>
import { useScreenState } from "../../store";
import { accountBase } from "../../utils/paccount";

export default {
    name: "Account",
    data() {
        return {
            screenState: useScreenState(),
        };
    },
    methods: {
    },
    beforeMount() {
        let token = window.localStorage.getItem('token')
        if (token) {
            let url = accountBase + '/#/mypage/userdata?'
            if (this.$route.query.tab == 1)
                url = accountBase + '/#/mypage/userdata?ctab=1&'
            this.$router.back()
            window.location.href = url + 'token=' + token
        }
        else {
            this.$router.replace('/account/login')
        }
    }
};
</script>

<style scoped>
</style>